module.exports = __webpack_public_path__ + "static/img/ssszdq.64d1b9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ssszdq.png
// module id = xH1T
// module chunks = 0